module.exports = __webpack_public_path__ + "img/mima_.60bcb82f.svg";